import {UniversalLifeGraceAFLetter} from 'Agent/Policies/api/apiTypes';
import React from 'react';
import CardField from 'Shared/components/CardField';
import {toFormattedDateAsUTC} from 'Shared/utilities/DateFormatter';
import {toMoneyValue} from 'Shared/utilities/FormatMoney';

export type GraceAFLetterProps = {
  graceAFLetter: UniversalLifeGraceAFLetter;
};

const GraceAFLetter = (props: GraceAFLetterProps) => {
  return (
    <>
      <CardField name="Date" value={toFormattedDateAsUTC(props.graceAFLetter.date)} ddprivacy="mask"/>
      <CardField name="Owner Name" value={props.graceAFLetter.ownerName} ddprivacy="mask"/>
      <CardField name="Owner Address" value={props.graceAFLetter.ownerAddress!.fullAddress} ddprivacy="mask"/>
      <CardField name="Insured Name" value={props.graceAFLetter.insuredName} ddprivacy="mask"/>
      <CardField name="Agent Number" value={props.graceAFLetter.agentNumber} ddprivacy="mask"/>
      <CardField name="Premium Due" value={toMoneyValue(props.graceAFLetter.premiumDue)} />
    </>
  );
};

export default GraceAFLetter;
